module.exports = __webpack_public_path__ + "static/media/studio-etc19.3eb3080b.png";